var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleAngleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.361,
    height: 19.716,
    viewBox: "0 0 21.361 19.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "angles-left",
    d: "M17.421,73.834,10.366,66.78a1.643,1.643,0,0,1,2.323-2.323L20.9,72.671a1.642,1.642,0,0,1,0,2.323L12.69,83.209a1.639,1.639,0,0,1-2.322,0,1.642,1.642,0,0,1,0-2.323Zm-9.86,0L.506,66.78A1.643,1.643,0,0,1,2.83,64.456l8.215,8.215a1.642,1.642,0,0,1,0,2.323L2.83,83.209a1.61,1.61,0,0,1-1.158.483,1.643,1.643,0,0,1-1.161-2.8Z",
    transform: "translate(-0.025 -63.975)",
    fill: "#d1002a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleAngleRight);
export default __webpack_public_path__ + "static/media/Double-angle-right.8b447ef2a17e9e18631fa8f1a7fd8a0f.svg";
export { ForwardRef as ReactComponent };